import { useQuery } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { animalPaths } from '../queries/paths';

// TSS vite/03 — typeahead de animales por `q` (name/number/register, ILIKE;
// GET /admin/animals, api-reference/admin-animals.md). q < 2 chars → no dispara
// (evita traer el hato entero). `extra` permite acotar (sex, is_external, status…).

export function useAnimalSearch(q, { limit = 10, extra } = {}) {
    const term = (q || '').trim();
    return useQuery({
        queryKey: ['animals', 'search', term, limit, extra || null],
        queryFn:  ({ signal }) =>
            api.get(animalPaths.list(), { params: { q: term, limit, sort: 'name', ...extra }, signal }).then(r => r.data),
        enabled: term.length >= 2,
        placeholderData: (prev) => prev,
    });
}
